import { PayloadAction } from '@reduxjs/toolkit';
import { CampaignOptionSlice } from './types';
import { REDUX_KEY, TVNZ_NETWORK } from '../../constants';
import { DAY_LOWERCASE, VARIABLE_OPTION } from '../../../constants/common';

export const updatePeakPercentageReducer = (
  state: CampaignOptionSlice,
  action: PayloadAction<{ value: number }>
) => {
  const { value } = action.payload;
  return { ...state, [REDUX_KEY.PEAK_PERCENTAGE]: value };
};

export const updateNetworkReducer = (
  state: CampaignOptionSlice,
  action: PayloadAction<{ network: TVNZ_NETWORK; value: number }>
) => {
  const { value, network } = action.payload;
  return {
    ...state,
    [REDUX_KEY.NETWORK_BREAKDOWN_PERCENTAGE]: {
      ...state[REDUX_KEY.NETWORK_BREAKDOWN_PERCENTAGE],
      [network]: value
    }
  };
};

export const toggleDayReducer = (
  state: CampaignOptionSlice,
  action: PayloadAction<{ day: DAY_LOWERCASE }>
) => {
  const { day } = action.payload;
  return {
    ...state,
    [REDUX_KEY.DAYS]: {
      ...state[REDUX_KEY.DAYS],
      [day]: !state.days[day]
    }
  };
};

export const setEditModeReducer = (
  state: CampaignOptionSlice,
  action: PayloadAction<{ mode: VARIABLE_OPTION | undefined }>
) => {
  const { mode } = action.payload;
  return { ...state, [REDUX_KEY.EDIT_MODE]: mode };
};
